
import "./Intro.scss";

const IntroSection = () => {
    return (
        <section className="intro-section">
            <div className={"intro-title"}>Know Your Body. <span>Own Your Game.</span></div>

            <div className={"intro-text-content"}>
                <div>
                    Get your AI-powered full-body musculoskeletal assessment and uncover exactly how your body moves — all from your smartphone or desktop.
                </div>
                <div style={{ marginTop: "20px" }}>
                    In minutes, Atlas Athlete AI reveals your mobility, balance, and performance data and provides a personalized plan to train smarter, prevent injuries, and dominate your sport.
                </div>
            </div>
        </section>
    );
};

export default IntroSection;
